// Per-server module catalog. Single source of truth shared by the
// admin UI, the Primary Sidebar rail, and the GET/PATCH endpoints in
// os-spaces. Adding a new module is a code release (bump @os/contracts
// + the consumers) — never a runtime DB write — because every consumer
// needs the matching UI metadata + Prisma client to render it.
export const MODULE_CATALOG = [
    { key: 'desktop', label: 'Desktop', status: 'live' },
    { key: 'dashboards', label: 'Dashboards', status: 'live' },
    { key: 'tracker', label: 'Tracker', status: 'live' },
    { key: 'mail', label: 'Mail', status: 'live' },
    { key: 'calendar', label: 'Calendar', status: 'live' },
    { key: 'people', label: 'People', status: 'live' },
    { key: 'tasks', label: 'Tasks', status: 'live' },
    { key: 'crm', label: 'CRM', status: 'live' },
    { key: 'service', label: 'Service', status: 'live' },
    { key: 'hr', label: 'HR & Recruiting', status: 'live' },
    // Finance is a vision mock with no backend (MRR/cash/ledger absent) — hidden
    // from the rail (rail:false) until a real finance backend exists. The route
    // /workspace/finance redirects (App.tsx) so it isn't user-reachable.
    { key: 'finance', label: 'Finance', status: 'mock', rail: false },
    { key: 'knowledge', label: 'Knowledge', status: 'live' },
    { key: 'notes', label: 'Notes', status: 'live' },
    { key: 'sign', label: 'Sign', status: 'live' },
    { key: 'learning', label: 'Learning', status: 'live' },
    { key: 'vault', label: 'Vault', status: 'live' },
    { key: 'probe', label: 'Probe', status: 'live' },
    { key: 'trust', label: 'Trust', status: 'live' },
    { key: 'mdm', label: 'Device Management', status: 'live' },
    { key: 'files', label: 'Files', status: 'live' },
    { key: 'monitoring', label: 'Monitoring', status: 'live', rail: false },
    { key: 'ai', label: 'AI Layer', status: 'mock' },
    { key: 'assistant', label: 'AI Assistant', status: 'live', rail: false },
];
// Missing key OR null/undefined ⇒ enabled. Lets a freshly-released
// module become visible everywhere without a DB backfill; admins opt
// out via the global admin panel when they need to.
export function isModuleEnabled(enabled, key) {
    // Device Management is a paid, high-authority organization extension.
    // Unlike legacy modules it is unavailable until a tenant explicitly opts in.
    if (key === 'mdm')
        return enabled?.mdm === true;
    if (!enabled)
        return true;
    if (!(key in enabled))
        return true;
    return enabled[key] !== false;
}
// Whether a catalog entry renders as a Primary-Sidebar nav icon. Feature-
// toggle modules (rail:false, e.g. AI Assistant) are admin-toggleable +
// gated in code but never appear as a rail entry. Accepts a widened
// ModuleCatalogEntry so callers can pass `as const` catalog members
// (whose literal types omit the optional `rail`).
export function isRailModule(entry) {
    return entry.rail !== false;
}
// Defends the PATCH endpoint from junk input: keeps only catalog keys
// and coerces values to boolean.
export function sanitizeEnabledModules(input) {
    const out = {};
    if (!input || typeof input !== 'object')
        return out;
    const valid = new Set(MODULE_CATALOG.map((m) => m.key));
    for (const [k, v] of Object.entries(input)) {
        if (valid.has(k))
            out[k] = v !== false;
    }
    return out;
}
//# sourceMappingURL=modules.js.map